module.exports = require("./de-CH.js");